module.exports = __webpack_public_path__ + "img/coupon_bg_01.2032e8b0.jpg";